import { z } from 'zod'

export const ActivityFeedFormSchema = z.object({
  content: z.string().min(1),
})

export type ActivityFeedFormSchemaType = z.infer<typeof ActivityFeedFormSchema>
